// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#onboarding {
  flex: 1 1;
  position: relative;
  width: 100%;
}

#onboarding .slide {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  inset: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  transition: all 1s;
  visibility: hidden;
  width: 100%;
}

#onboarding .slide .content {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  max-width: 800px;
  width: 100%;
}

#onboarding .slide .content > span {
  color: #fff;
  font-size: 2.5rem;
  text-align: center;
  width: 90%;
  word-wrap: break-word;
}

#onboarding .slide .scrollable {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
}

#onboarding .box {
  background-color: #FFD55D;
  border-radius: 2vh;
  display: flex;
  flex-direction: column;
  padding: 2vh 5%;
  width: 90%;
}

#onboarding .box span {
  text-align: center;
}

#onboarding .skip {
  bottom: 0;
  color: #07144C;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 3vh;
}

#onboarding .slide:not(.question) .skip {
  position: absolute;
}

#onboarding .question {
  background: linear-gradient(180deg, rgba(255,207,86,1) 1%, rgba(255,229,111,1) 54%, rgba(255,247,210,1) 91%, rgba(255,253,243,1) 100%);
  flex-direction: column;
  overflow: hidden;
}

#onboarding .question .content > span {
  color: #07144C;
  font-size: calc(max(1.25rem, 3vh));
  margin: 10vh 0 3vh 0;
}

#onboarding .question .box {
  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);
  color: #07144C;
  cursor: pointer;
  font-size: 1.25rem;
  margin-top: 1rem;
  padding: 3vh 0;
  text-align: center;
  width: 80%;
}

#onboarding .question .skip {
  margin: 3vh 0;
}

#onboarding #slide0 {
  background: linear-gradient(0deg, rgba(87,53,237,1) 0%, rgba(71,100,230,1) 16%, rgba(54,147,223,1) 34%, rgba(55,186,212,1) 50%, rgba(55,205,207,1) 73%);
  opacity: 1;
  visibility: visible;
}

#onboarding #slide1 {
  background: linear-gradient(0deg, rgba(87,53,237,1) 0%, rgba(71,100,230,1) 16%, rgba(54,147,223,1) 34%, rgba(55,186,212,1) 50%, rgba(55,205,207,1) 73%);
  cursor: pointer;
}

#onboarding #slide2 {
  background: linear-gradient(0deg, rgba(71,100,230,1) 0%, rgba(54,147,223,1) 18%, rgba(55,186,212,1) 39%, rgba(110,239,196,1) 73%);
}

#onboarding #slide3 {
  background: linear-gradient(0deg, rgba(54,147,223,1) 0%, rgba(55,186,212,1) 31%, rgba(148,220,200,1) 53%, rgba(195,238,194,1) 64%, rgba(241,255,186,1) 75%);
}

#onboarding #slide4 {
  background: linear-gradient(0deg, rgba(54,147,223,1) 0%, rgba(148,220,200,1) 22%, rgba(202,235,185,1) 37%, rgba(228,242,177,1) 51%, rgba(242,246,173,1) 61%, rgba(255,249,169,1) 70%);
}

#onboarding #slide4 .content > span {
  background: linear-gradient(90deg, rgba(132,82,150,1) 67%, rgba(35,50,137,1) 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

#onboarding #slide5 {
  background: linear-gradient(180deg, rgba(255,244,141,1) 0%, rgba(255,229,111,1) 41%, rgba(255,247,210,1) 71%, rgba(255,253,243,1) 100%);
}

#onboarding #slide5 .box span {
  background: linear-gradient(90deg, rgba(132,82,150,1) 19%, rgba(35,50,137,1) 79%);
  background-clip: text;
  font-size: 2rem;
  text-align: center;
  -webkit-text-fill-color: transparent;
}

#onboarding #slide6 {
  background: linear-gradient(180deg, rgba(255,207,86,1) 1%, rgba(255,229,111,1) 54%, rgba(255,247,210,1) 91%, rgba(255,253,243,1) 100%);
}

#onboarding #slide6 .content > span {
  background: linear-gradient(90deg, rgba(132,82,150,1) 0%, rgba(35,50,137,1) 60%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

#onboarding #slide8, #onboarding #slide10 {
  background: linear-gradient(180deg, rgba(255,207,86,1) 1%, rgba(255,229,111,1) 54%, rgba(255,247,210,1) 91%, rgba(255,253,243,1) 100%);
}`, "",{"version":3,"sources":["webpack://./src/components/onboarding/Onboarding.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sIAAsI;EACtI,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uJAAuJ;EACvJ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,uJAAuJ;EACvJ,eAAe;AACjB;;AAEA;EACE,iIAAiI;AACnI;;AAEA;EACE,2JAA2J;AAC7J;;AAEA;EACE,qLAAqL;AACvL;;AAEA;EACE,kFAAkF;EAClF,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,uIAAuI;AACzI;;AAEA;EACE,iFAAiF;EACjF,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,gFAAgF;EAChF,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,sIAAsI;AACxI","sourcesContent":["#onboarding {\n  flex: 1;\n  position: relative;\n  width: 100%;\n}\n\n#onboarding .slide {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  inset: 0;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  transition: all 1s;\n  visibility: hidden;\n  width: 100%;\n}\n\n#onboarding .slide .content {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n  max-width: 800px;\n  width: 100%;\n}\n\n#onboarding .slide .content > span {\n  color: #fff;\n  font-size: 2.5rem;\n  text-align: center;\n  width: 90%;\n  word-wrap: break-word;\n}\n\n#onboarding .slide .scrollable {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n#onboarding .box {\n  background-color: #FFD55D;\n  border-radius: 2vh;\n  display: flex;\n  flex-direction: column;\n  padding: 2vh 5%;\n  width: 90%;\n}\n\n#onboarding .box span {\n  text-align: center;\n}\n\n#onboarding .skip {\n  bottom: 0;\n  color: #07144C;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: bold;\n  margin-bottom: 3vh;\n}\n\n#onboarding .slide:not(.question) .skip {\n  position: absolute;\n}\n\n#onboarding .question {\n  background: linear-gradient(180deg, rgba(255,207,86,1) 1%, rgba(255,229,111,1) 54%, rgba(255,247,210,1) 91%, rgba(255,253,243,1) 100%);\n  flex-direction: column;\n  overflow: hidden;\n}\n\n#onboarding .question .content > span {\n  color: #07144C;\n  font-size: calc(max(1.25rem, 3vh));\n  margin: 10vh 0 3vh 0;\n}\n\n#onboarding .question .box {\n  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);\n  color: #07144C;\n  cursor: pointer;\n  font-size: 1.25rem;\n  margin-top: 1rem;\n  padding: 3vh 0;\n  text-align: center;\n  width: 80%;\n}\n\n#onboarding .question .skip {\n  margin: 3vh 0;\n}\n\n#onboarding #slide0 {\n  background: linear-gradient(0deg, rgba(87,53,237,1) 0%, rgba(71,100,230,1) 16%, rgba(54,147,223,1) 34%, rgba(55,186,212,1) 50%, rgba(55,205,207,1) 73%);\n  opacity: 1;\n  visibility: visible;\n}\n\n#onboarding #slide1 {\n  background: linear-gradient(0deg, rgba(87,53,237,1) 0%, rgba(71,100,230,1) 16%, rgba(54,147,223,1) 34%, rgba(55,186,212,1) 50%, rgba(55,205,207,1) 73%);\n  cursor: pointer;\n}\n\n#onboarding #slide2 {\n  background: linear-gradient(0deg, rgba(71,100,230,1) 0%, rgba(54,147,223,1) 18%, rgba(55,186,212,1) 39%, rgba(110,239,196,1) 73%);\n}\n\n#onboarding #slide3 {\n  background: linear-gradient(0deg, rgba(54,147,223,1) 0%, rgba(55,186,212,1) 31%, rgba(148,220,200,1) 53%, rgba(195,238,194,1) 64%, rgba(241,255,186,1) 75%);\n}\n\n#onboarding #slide4 {\n  background: linear-gradient(0deg, rgba(54,147,223,1) 0%, rgba(148,220,200,1) 22%, rgba(202,235,185,1) 37%, rgba(228,242,177,1) 51%, rgba(242,246,173,1) 61%, rgba(255,249,169,1) 70%);\n}\n\n#onboarding #slide4 .content > span {\n  background: linear-gradient(90deg, rgba(132,82,150,1) 67%, rgba(35,50,137,1) 100%);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n#onboarding #slide5 {\n  background: linear-gradient(180deg, rgba(255,244,141,1) 0%, rgba(255,229,111,1) 41%, rgba(255,247,210,1) 71%, rgba(255,253,243,1) 100%);\n}\n\n#onboarding #slide5 .box span {\n  background: linear-gradient(90deg, rgba(132,82,150,1) 19%, rgba(35,50,137,1) 79%);\n  background-clip: text;\n  font-size: 2rem;\n  text-align: center;\n  -webkit-text-fill-color: transparent;\n}\n\n#onboarding #slide6 {\n  background: linear-gradient(180deg, rgba(255,207,86,1) 1%, rgba(255,229,111,1) 54%, rgba(255,247,210,1) 91%, rgba(255,253,243,1) 100%);\n}\n\n#onboarding #slide6 .content > span {\n  background: linear-gradient(90deg, rgba(132,82,150,1) 0%, rgba(35,50,137,1) 60%);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n#onboarding #slide8, #onboarding #slide10 {\n  background: linear-gradient(180deg, rgba(255,207,86,1) 1%, rgba(255,229,111,1) 54%, rgba(255,247,210,1) 91%, rgba(255,253,243,1) 100%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
